import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetUserLogger = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_USER_LOGGER
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetUserLoggerAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetUserLogger as SetGetUserLogger
}